import { render, staticRenderFns } from "./register.vue?vue&type=template&id=3c3eda80&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=3c3eda80&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./register.vue?vue&type=style&index=1&id=3c3eda80&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3eda80",
  null
  
)

export default component.exports